export default __webpack_public_path__ + "static/media/icon.b799d1b4.png";